// src/pages/SearchResultsPage.js
import React, { useState, useEffect, useCallback } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import './SearchResultsPage.css';
import SearchBar from '../components/SearchBar';
import PodcastCard from '../components/PodcastCard';
import Header from '../components/Header';
import { searchPodcasts } from '../utils/apiHelpers';

const SearchResultsPage = () => {
  const { query } = useParams();
  const navigate = useNavigate();

  const [results, setResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleResultsPageSearch = useCallback((newQuery) => {
    if (newQuery.trim() !== '') {
      navigate(`/search-results/${encodeURIComponent(newQuery.trim())}`);
    }
  }, [navigate]);

  useEffect(() => {
    if (!query) return;

    const fetchSearchResults = async () => {
      setIsLoading(true);
      setError(null);
      setResults([]);

      try {
        const feeds = await searchPodcasts(query, 8);
        setResults(feeds);
      } catch (err) {
        console.error("Error fetching search results:", err);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSearchResults();

  }, [query]);

  if (isLoading) {
    return (
      <>
        <Header />
        <div className="search-results-container">
          <div className="results-search-bar-container">
            <SearchBar
              onSearchSubmit={handleResultsPageSearch}
              initialQuery={query}
              size="large"
              className="results-page-search-form"
            />
          </div>
          <h2 className="results-heading">Search Results for "{query}"</h2>
          <div className="results-grid">
            {[...Array(8)].map((_, i) => (
              <div key={i} className="podcast-card-skeleton">
                <div className="skeleton-img" />
                <div className="skeleton-title" />
                <div className="skeleton-author" />
              </div>
            ))}
          </div>
        </div>
      </>
    );
  }

  if (error) {
    return <div className="error-message">Error fetching results: {error}. Please try again or check API setup.</div>;
  }

  return (
    <>
      <Header />
      <div className="search-results-container">
        <div className="results-search-bar-container">
          <SearchBar
            onSearchSubmit={handleResultsPageSearch}
            initialQuery={query}
            size="large"
            className="results-page-search-form"
          />
        </div>

        <h2 className="results-heading">Search Results for "{query}"</h2>

        {results.length > 0 ? (
          <div className="results-grid">
            {results.map((podcast) => (
              <PodcastCard key={podcast.id} podcast={podcast} />
            ))}
          </div>
        ) : (
          <p className="no-results-message">No podcasts found for "{query}". Try different keywords.</p>
        )}
        <div style={{ textAlign: 'center', marginTop: '30px' }}>
          <Link to="/home">Back to Home</Link>
        </div>
      </div>
    </>
  );
};

export default SearchResultsPage;